var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.changelog)?_c('vue-simple-markdown',{attrs:{"source":_vm.changelog}}):_c('loading')}
var staticRenderFns = []

export { render, staticRenderFns }